var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 42q-1.2 0-2.1-.9Q6 40.2 6 39V9q0-1.2.9-2.1Q7.8 6 9 6h10.65v3H9v30h30V25.45l3 3V39q0 1.2-.9 2.1-.9.9-2.1.9Zm2.85-7.85 5.85-7.55 4.65 6.3 6.5-8.5 7.35 9.75Zm31.9-8.25-6.65-6.65q-1.05.7-2.075 1.025Q34 20.6 32.6 20.6q-3.5 0-5.9-2.4-2.4-2.4-2.4-5.9 0-3.5 2.4-5.9Q29.1 4 32.6 4q3.5 0 5.9 2.4 2.4 2.4 2.4 5.9 0 1.4-.4 2.65t-1.1 2.3l6.5 6.5ZM32.6 17.6q2.3 0 3.8-1.5t1.5-3.8q0-2.3-1.5-3.8T32.6 7q-2.3 0-3.8 1.5t-1.5 3.8q0 2.3 1.5 3.8t3.8 1.5Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSearch);
export default __webpack_public_path__ + "static/media/ImageSearch.593ff40ed596418539fa8ea436b85159.svg";
export { ForwardRef as ReactComponent };